(() => {
  'use strict';

  const SELECTORS = {
    willItFitAccordion: 'details[id*="will_it_fit"]',
    kiwiWidget: '.ks-chart-container.sizing-chart-container.ks-container-with-modal',
    deliveryAccordion: 'details[id*="delivery"]',
    deliveryContent: '.accordion__content.rte'
  };

  const NEW_DELIVERY_HTML = `
    <p>This item is classed as a Small Parcel Delivery; the delivery information below may change at checkout if you add more items to your order.</p>
    
    <table class="table__table">
      <tbody>
        <tr class="table__row">
          <th class="table__label">Order Type</th>
          <th class="table__label small-hide">Cost</th>
          <th class="table__label small-hide">Timeframe</th>
          <th class="table__label medium-hide large-up-hide">Cost & Timeframe</th>
        </tr>
        <tr class="table__row">
          <td>Small Parcel Standard Delivery (Over £75)</td>
          <td class="small-hide">FREE</td>
          <td class="small-hide">Delivered in 3-5 working days</td>
          <td class="medium-hide large-up-hide">
            <strong>Cost</strong>: FREE<br>
            <strong>Timeframe</strong>: Delivered in 3-5 working days
          </td>
        </tr>
        <tr class="table__row">
          <td>Small Parcel Standard Delivery (Under £75)</td>
          <td class="small-hide">£3.99</td>
          <td class="small-hide">Delivered in 3-5 working days</td>
          <td class="medium-hide large-up-hide">
            <strong>Cost</strong>: £3.99<br>
            <strong>Timeframe</strong>: Delivered in 3-5 working days
          </td>
        </tr>
        <tr class="table__row">
          <td>Small Parcel Next Working Day Delivery*</td>
          <td class="small-hide">£5.99</td>
          <td class="small-hide">Next Working Day*</td>
          <td class="medium-hide large-up-hide">
            <strong>Cost</strong>: £5.99<br>
            <strong>Timeframe</strong>: Next Working Day*
          </td>
        </tr>
      </tbody>
    </table>
    
    <p><strong>Delivery costs are calculated based on the total weight of your delivery and are confirmed at the checkout.</strong></p>
    <p>*All timeframes are from when the items are in stock. Please read full details of our delivery options and timeframes prior to placing your order <a href="/pages/delivery" target="_blank">here</a>.</p>
  `;

  const isCorePDP = () => {
    if (typeof KiwiSizing !== 'undefined' && KiwiSizing.data && KiwiSizing.data.tags) {
      const tags = Array.isArray(KiwiSizing.data.tags) 
        ? KiwiSizing.data.tags 
        : KiwiSizing.data.tags.split(',').map(t => t.trim());
      return tags.some(tag => tag === 'Core');
    }
    return false;
  };

  const removeWillItFitAccordion = () => {
    try {
      const accordion = document.querySelector(SELECTORS.willItFitAccordion);
      if (accordion) {
        const parent = accordion.closest('.accordion');
        if (parent) {
          parent.remove();
        } else {
          accordion.remove();
        }
      }
    } catch (error) {
      console.warn('Error removing Will it Fit accordion:', error);
    }
  };

  const removeKiwiWidget = () => {
    try {
      const widgets = document.querySelectorAll(SELECTORS.kiwiWidget);
      if (widgets && widgets.length > 0) {
        widgets.forEach(widget => widget.remove());
      }
    } catch (error) {
      console.warn('Error removing Kiwi widget:', error);
    }
  };

  const simplifyDeliveryAccordion = () => {
    try {
      const deliveryDetails = document.querySelector(SELECTORS.deliveryAccordion);
      if (!deliveryDetails) return;

      const contentDiv = deliveryDetails.querySelector(SELECTORS.deliveryContent);
      if (!contentDiv) return;

      contentDiv.innerHTML = NEW_DELIVERY_HTML;
    } catch (error) {
      console.warn('Error simplifying delivery accordion:', error);
    }
  };

  const applyChanges = () => {
    if (!isCorePDP()) return;

    removeWillItFitAccordion();
    removeKiwiWidget();
    simplifyDeliveryAccordion();
  };

  const observeAndApply = () => {
    let hasRun = false;
    let observer = null;

    const checkAndApply = () => {
      if (hasRun) return;
      
      const deliveryAccordion = document.querySelector(SELECTORS.deliveryAccordion);
      if (deliveryAccordion) {
        hasRun = true;
        applyChanges();
        if (observer) {
          observer.disconnect();
          observer = null;
        }
      }
    };

    checkAndApply();

    if (!hasRun) {
      const pdpSection = document.querySelector('#MainProduct-, .product-details-accordion-wrapper, .product__info-container');
      const observerRoot = pdpSection || document.body;

      observer = new MutationObserver(() => {
        checkAndApply();
      });

      observer.observe(observerRoot, {
        childList: true,
        subtree: true
      });

      // 10 seconds timeout
      setTimeout(() => {
        if (observer) {
          observer.disconnect();
          observer = null;
        }
      }, 10000);
    }
  };

  const activateVariant = () => {
    document.documentElement.classList.add('convert-core-pdp-simplify');
    document.documentElement.setAttribute('data-convert-core-pdp', 'variant');

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAndApply);
    } else {
      observeAndApply();
    }
  };

  const deactivateVariant = () => {
    document.documentElement.classList.remove('convert-core-pdp-simplify');
    document.documentElement.removeAttribute('data-convert-core-pdp');
  };

  window.convertCorePdpSimplify = {
    control() {
      deactivateVariant();
    },
    variant() {
      activateVariant();
    },
    reset() {
      this.control();
    }
  };

  document.addEventListener('page:load', () => window.convertCorePdpSimplify.control?.());
})();
